import { render, staticRenderFns } from "./otherIndex.vue?vue&type=template&id=1177dac0&scoped=true&"
import script from "./otherIndex.vue?vue&type=script&lang=js&"
export * from "./otherIndex.vue?vue&type=script&lang=js&"
import style0 from "./otherIndex.vue?vue&type=style&index=0&id=1177dac0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1177dac0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1177dac0')) {
      api.createRecord('1177dac0', component.options)
    } else {
      api.reload('1177dac0', component.options)
    }
    module.hot.accept("./otherIndex.vue?vue&type=template&id=1177dac0&scoped=true&", function () {
      api.rerender('1177dac0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tvView/otherIndex.vue"
export default component.exports